import React from "react";
import { Box, Paper, Typography, Avatar, Stack } from "@mui/material";

const TimelineItem = ({
  icon,
  iconColor = "primary",
  timestamp,
  changedBy,
  children,
  image_url,
}) => {
  const getColor = (color) => {
    const colorMap = {
      primary: "primary.main",
      success: "success.main",
      warning: "warning.main",
      error: "error.main",
      info: "info.main",
    };
    return colorMap[color] || "primary.main";
  };

  return (
    <Box
      sx={{
        display: "flex",
        gap: 2,
        position: "relative",
        alignItems: "flex-start",
        "&:not(:last-child)::after": {
          content: '""',
          position: "absolute",
          left: 19,
          top: 40,
          bottom: -24,
          width: "4px",
          backgroundColor: "grey.300",
          zIndex: 1,
        },
      }}
    >
      <Avatar
        sx={{
          bgcolor: getColor(iconColor),
          width: 40,
          height: 40,
          zIndex: 2,
          flexShrink: 0,
          position: "relative",
        }}
      >
        {icon}
      </Avatar>

      <Paper
        elevation={1}
        sx={{
          flex: 1,
          p: 3,
          minHeight: 80,
          border: "1px solid",
          borderColor: "grey.200",
          position: "relative",
        }}
      >
        <Box sx={{ mb: 2 }}>
          <Stack direction="row" alignItems="center" spacing={1.5}>
            <Avatar
              sx={{
                width: 40,
                height: 40,
                fontSize: "1.1rem",
                fontWeight: "bold",
              }}
              alt={changedBy?.charAt(0).toUpperCase()}
              src={image_url}
            />
            <Box>
              <Typography
                variant="subtitle1"
                sx={{
                  fontWeight: 700,
                  fontSize: "1.1rem",
                  lineHeight: 1.2,
                }}
              >
                {changedBy ?? "-"}
              </Typography>
              <Typography
                variant="body2"
                sx={{
                  color: "text.secondary",
                  fontSize: "0.8rem",
                  mt: 0.5,
                }}
              >
                {timestamp}
              </Typography>
            </Box>
          </Stack>
        </Box>
        <Box sx={{ mt: 1 }}>{children}</Box>
      </Paper>
    </Box>
  );
};

export default TimelineItem;
